module.exports = __webpack_public_path__ + "static/scale-model-of-the-sixth-floor-museum-at-dealey-plaza-in-dallas-texas-cf8ae15dbb268ba206196cccbe67f608.png";